export const MODAL__PUSH = 'MODAL__PUSH';
export const MODAL__REMOVE = 'MODAL__REMOVE';

export const MODAL__HIDE = 'MODAL__HIDE';
export const MODAL__SHOW = 'MODAL__SHOW';

export const MODAL__SURVEY_SHARE = 'SurveyShareModal';
export const MODAL__SURVEY_PUBLISH = 'SurveyPublishModal';
